import { render } from "./WpeDivider.vue?vue&type=template&id=dec84df4"
import script from "./WpeDivider.vue?vue&type=script&lang=js"
export * from "./WpeDivider.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/controls/WpeDivider.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "dec84df4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('dec84df4', __exports__)) {
    api.reload('dec84df4', __exports__)
  }
  
  module.hot.accept("./WpeDivider.vue?vue&type=template&id=dec84df4", () => {
    api.rerender('dec84df4', render)
  })

}


export default __exports__